import { render, staticRenderFns } from "./SitesStatsTable.vue?vue&type=template&id=6130ba6c"
import script from "./SitesStatsTable.vue?vue&type=script&lang=js"
export * from "./SitesStatsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports